import React, { useEffect, useState, useRef } from 'react';
import { LockIcon, EyeIcon, EyeOffIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { VersionStamp } from '../components/VersionStamp';
interface LoginProps {
  onLogin: () => void;
}
export function Login({
  onLogin
}: LoginProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [isOrbActive, setIsOrbActive] = useState(false);
  const orbRef = useRef<HTMLImageElement>(null);
  useEffect(() => {
    if (isOrbActive && orbRef.current) {
      const currentRotation = window.getComputedStyle(orbRef.current).transform;
      orbRef.current.style.setProperty('--rotation', currentRotation);
    }
  }, [isOrbActive]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === 'quadgrow2026') {
      setIsOrbActive(true);
      setTimeout(() => {
        setIsOrbActive(false);
        onLogin();
      }, 1500);
    } else {
      setError('Incorrect password');
    }
  };
  const handleFocus = () => {
    setIsFocused(true);
    setIsOrbActive(true);
    setTimeout(() => {
      setIsOrbActive(false);
    }, 1500);
  };
  const handleBlur = () => {
    setIsFocused(false);
  };
  return <div className="min-h-screen w-full relative flex items-center justify-center p-4 overflow-hidden" data-demo="login-screen" data-id="element-2031">
      <div className="absolute inset-0 bg-gradient-to-br from-[#0A1A33] via-[#081526] to-[#060E1B]" data-id="element-2032" />
      <div className="absolute inset-0 overflow-hidden pointer-events-none" data-id="element-2033">
        {[...Array(15)].map((_, i) => <motion.div key={i} className="absolute w-1 h-1 bg-white rounded-full opacity-10" style={{
        left: `${Math.random() * 100}%`,
        top: `${Math.random() * 100}%`
      }} animate={{
        y: [-20, -100],
        opacity: [0.1, 0.3, 0.1]
      }} transition={{
        duration: 4 + Math.random() * 3,
        repeat: Infinity,
        delay: Math.random() * 3,
        ease: 'easeOut'
      }} data-id="element-2034" />)}
      </div>
      <div className="relative z-10 w-full max-w-md" data-id="element-2035">
        <div className="flex justify-center mb-4" data-id="element-2036">
          <div className="relative" data-id="element-2037">
            <div className="absolute inset-0 -z-10 pointer-events-none" style={{
            background: 'radial-gradient(circle at center, rgba(30, 144, 255, 0.2) 0%, transparent 70%)',
            width: '350px',
            height: '350px',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)'
          }} data-id="element-2038" />
            <img ref={orbRef} src="https://uploadthingy.s3.us-west-1.amazonaws.com/8K6mHYizErpn7PdiNKwZ7R/glow-only-atlas-orb-transparent.png" alt="Atlas Orb" className={`w-[180px] h-[180px] md:w-[240px] md:h-[240px] mx-auto ${isOrbActive ? 'animate-orb-interact' : 'animate-rotate-orb'}`} style={{
            filter: 'drop-shadow(0 0 30px rgba(30, 144, 255, 0.4))',
            opacity: 1
          }} data-id="element-2039" />
          </div>
        </div>
        <motion.div className="text-center mb-8" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} data-id="element-2040">
          <h1 className="text-4xl font-semibold text-white mb-3 font-sans" data-id="element-2041">
            Quad Atlas
          </h1>
          <motion.p className="text-slate-300 text-lg" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 0.7
        }} data-id="element-2042">
            Account Intelligence for Every Team
          </motion.p>
        </motion.div>
        <motion.div className="backdrop-blur-xl bg-slate-900/60 border border-slate-800/50 rounded-2xl p-8 shadow-2xl" initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.5
      }} data-id="element-2043">
          <form onSubmit={handleSubmit} className="space-y-6" data-id="element-2044">
            <div data-id="element-2045">
              <label htmlFor="password" className="block text-sm font-medium text-slate-300 mb-2 font-sans" data-id="element-2046">
                Enter Demo Password
              </label>
              <div className="relative" data-id="element-2047">
                <motion.div className="absolute left-3 top-1/2 -translate-y-1/2" animate={{
                color: isFocused ? '#1E90FF' : '#64748b'
              }} transition={{
                duration: 0.2
              }} data-id="element-2048">
                  <LockIcon className="w-5 h-5" data-id="element-2049" />
                </motion.div>
                <input id="password" type={showPassword ? 'text' : 'password'} value={password} onChange={e => {
                setPassword(e.target.value);
                setError('');
              }} onFocus={handleFocus} onBlur={handleBlur} className="w-full pl-10 pr-12 py-3 bg-slate-950/80 border border-slate-700 rounded-lg text-white placeholder-slate-500 focus:outline-none focus:border-[#1E90FF] focus:ring-2 focus:ring-[#1E90FF]/40 transition-all font-sans" placeholder="Enter password" autoFocus data-id="element-2050" />
                <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 hover:text-slate-300 transition-colors" aria-label={showPassword ? 'Hide password' : 'Show password'} data-id="element-2051">
                  {showPassword ? <EyeOffIcon className="w-5 h-5" data-id="element-2052" /> : <EyeIcon className="w-5 h-5" data-id="element-2053" />}
                </button>
              </div>
              {error && <motion.p initial={{
              opacity: 0,
              y: -10
            }} animate={{
              opacity: 1,
              y: 0
            }} className="mt-2 text-sm text-red-400 font-sans" data-id="element-2054">
                  {error}
                </motion.p>}
            </div>
            <motion.button type="submit" className="w-full py-3 rounded-lg font-medium text-white transition-all relative overflow-hidden font-sans" style={{
            background: 'linear-gradient(135deg, #1E90FF 0%, #007BFF 100%)',
            fontWeight: 500
          }} whileHover={{
            scale: 1.02,
            boxShadow: '0 0 30px rgba(30, 144, 255, 0.4)'
          }} whileTap={{
            scale: 0.98
          }} data-id="element-2055">
              <motion.div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent" animate={{
              x: ['-200%', '200%']
            }} transition={{
              duration: 2,
              repeat: Infinity,
              ease: 'linear'
            }} data-id="element-2056" />
              <span className="relative z-10" data-id="element-2057">Access Demo</span>
            </motion.button>
          </form>
        </motion.div>
        <motion.div className="mt-8 text-center" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.8,
        delay: 1
      }} data-id="element-2058">
          
          <p className="text-xs text-slate-500 opacity-70 font-sans" data-id="element-2059">
            <VersionStamp prefix="Quad Atlas Demo" data-id="element-2060" /> • Powered by Sprinklenet
            Knowledge Spaces
          </p>
        </motion.div>
      </div>
    </div>;
}